import countries from '../data/countries.json';
import { AppLocale } from './config';
import { getIntlLocale } from './formatting';

type CountryRecord = (typeof countries)[number];

const repairMojibake = (value: string): string => {
  if (!/[ÃÂâ]/.test(value)) return value;
  try {
    return decodeURIComponent(escape(value));
  } catch {
    return value;
  }
};

const normalizeCountryName = (value: string) =>
  repairMojibake(value).trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();

const countryByCode = new Map(countries.map((country) => [country.sigla.toUpperCase(), country]));
const countryByName = new Map<string, CountryRecord>();
countries.forEach((country) => {
  [country.nome_pais, country.nome_pais_int].forEach((name) => {
    countryByName.set(normalizeCountryName(name), country);
    countryByName.set(normalizeCountryName(repairMojibake(name)), country);
  });
});

export const resolveCountryCode = (value: unknown): string => {
  if (typeof value !== 'string' || !value.trim()) return '';
  const trimmed = value.trim();
  const byCode = countryByCode.get(trimmed.toUpperCase());
  if (byCode) return byCode.sigla;
  return countryByName.get(normalizeCountryName(trimmed))?.sigla ?? trimmed;
};

export const getCountryDisplayName = (value: unknown, locale: AppLocale | string): string => {
  if (typeof value !== 'string' || !value.trim()) return '';
  const code = resolveCountryCode(value);
  const record = countryByCode.get(code.toUpperCase());
  const intlName = record
    ? new Intl.DisplayNames([getIntlLocale(locale)], { type: 'region' }).of(record.sigla)
    : undefined;
  return intlName || (record ? repairMojibake(record.nome_pais) : '') || (record?.nome_pais_int ?? '') || code;
};

export const getCountryOptions = (locale: AppLocale | string) =>
  countries.map((country) => ({
    value: country.sigla,
    label: getCountryDisplayName(country.sigla, locale),
  }));

export const COUNTRY_CATALOG_NON_ISO_CODES = ['AC', 'DG', 'EA', 'IC', 'TA', 'XK'] as const;

